import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const VEHICLE_DETAILS = gql`
  query getVehicleInfoForWormwood(
    $market: MarketType!
    $lang: String!
    $id: String!
    $version: String
  ) {
    getVehicleInfoForWormwood(market: $market, lang: $lang, id: $id, version: $version) {
      audiCode
      bodyType
      dealerName
      dealerId
      driveType
      exteriorColor
      fuelType
      gearType
      interiorColor
      saleOrderType
      seatInfo
      modelPrice
      modelPriceRetail
      modelYear
      modelName
      modelPrice
      modelCode
      vin
      trimline
      trimName
      stockNumber
      isAvailableNow
      vehicleOrderStatus
      typedPrices {
        type
        formatted
        amount
      }
      vehicleInventoryType
      technicalSpecifications {
        transmissionType
        engineType
      }
      modelMake
      vehicleMedia {
        mediaImages {
          url
          imageType
          config
        }
      }
      dealerRegion
      kvpsSyncId
      stockNumber
      bodyType
      vehicleType
      exteriorColor
      fuelType
      oaddStockNumber
    }
  }
`;

// eslint-disable-next-line import/prefer-default-export
export const GET_FILTERED_VEHICLES = gql`
  query getFilteredVehiclesForWormwood(
    $version: String
    $market: [MarketType]!
    $limit: Int
    $lang: String!
    $filters: String
    $ranges: String
    $sort: String
    $offset: Int
    $preset: String
  ) {
    getFilteredVehiclesForWormwood(
      version: $version
      market: $market
      size: $limit
      lang: $lang
      filters: $filters
      ranges: $ranges
      sort: $sort
      from: $offset
      preset: $preset
    ) {
      filterResults {
        totalCount
      }
      vehicles {
        vin
        id
      }
    }
  }
`;
